/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectList_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterStyle_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilterStyle_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectList_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilterStyle_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterStyle_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectList_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '616078890cf75c7ef9c897c3fb0e4e2e';
module.exports = node;
